// Import Styles
import './styles/main.scss';

import { appConfig, appRun } from './app.config';
import './views';
import './directives';
import './filters';
import './resources';
import './services';
import './mixins/date_polyfill';
import AuthService from './services/auth_service'
import vsRepeat from 'angular-vs-repeat';
import { ENV } from 'environment';

// Create angular app and specify dependencies
angular.module('app', [
        'ngResource',
        'ngRoute',
        'ngTouch',
        'ngSanitize',
        'ngTagsInput',
        'angulartics',
        'angulartics.google.analytics',
        'ui.bootstrap',
        'toaster',
        'app.views',
        'app.directives',
        'app.filters',
        'app.resources',
        'app.services',
        'vs-repeat',
    ])
    .config(appConfig)
    .run(appRun);

// Work a little magic to delay app bootstrap until we've loaded the Config from the API
// Note: this relies on the Config service maintaining state on the window scope :-/
$(document).ready(() => {
    let auth = new AuthService;
    if (auth.isCallback()) {
        return auth.handleCallback();
    } else if (!auth.isLoggedIn()) {
        return auth.redirectToLogin();
    }

    const Config = angular.injector(['app']).get('Config');
    Config
      .promise
      .then(() => angular.bootstrap($('html'), ['app']))
      .catch((err) => {
        if (err && err.message != 'halt') {
          console.error(err);
          alert('Unable to load configuration. Please refresh the dashboard and try again.');
        }
        $('body > *').hide();
      });
});



// WEBPACK FOOTER //
// ./app.js